function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 306,
  height: 140,
  fill: "white",
  fillOpacity: 0.9
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M101.08 45H93V53.016H101.08V45Z",
  fill: "#D22730"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M101.08 58.6729H93V80.4268H101.08V58.6729Z",
  fill: "#D22730"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M114.878 58.6729H106.798V80.4268H114.878V58.6729Z",
  fill: "#D22730"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M106.734 45V53.016H117.487C117.487 53.016 120.222 52.706 120.222 55.814C120.222 58.92 120.222 80.426 120.222 80.426H128.178V50.906C128.178 50.906 128.302 45 121.339 45C114.628 45 106.734 45 106.734 45Z",
  fill: "#D22730"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M173.422 51.524V47.302H159.315V45H154.03V47.302H142.721C142.721 47.302 139.178 47.114 139.178 51.03C139.178 54.944 139.178 80.427 139.178 80.427H144.336V51.524H149.561V53.763H146.141V57.803H149.561V60.6H146.141V64.64H173.423V55.315C173.423 55.315 173.176 53.763 171.558 53.763C169.94 53.763 165.53 53.763 165.53 53.763V51.524H173.422ZM160.186 60.601H154.842V57.804H160.186V60.601ZM160.186 53.764H154.842V51.524H160.186V53.764ZM168.511 57.803V60.6H165.529V57.803H168.511Z",
  fill: "#595757"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M151.422 66.0068H146.14V77.3198C146.14 77.3198 146.201 80.4258 149.56 80.4258C152.915 80.4258 159.192 80.4258 159.192 80.4258V76.5718H151.423V71.9728H159.192V68.0568H151.423V66.0068H151.422Z",
  fill: "#595757"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M165.529 66.0068H160.247V77.3198C160.247 77.3198 160.307 80.4258 163.671 80.4258C167.023 80.4258 173.3 80.4258 173.3 80.4258V76.5718H165.529V71.9728H173.3V68.0568H165.529V66.0068Z",
  fill: "#595757"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M209.535 68.058C206.861 68.058 185.545 68.058 185.545 68.058V66.257H212.148V62.34H185.544V60.601H212.147V49.412C212.147 49.412 212.331 46.8 209.469 46.8C206.613 46.8 198.23 46.8 198.23 46.8L198.225 45H192.564V46.8H182.874C182.874 46.8 180.323 46.925 180.323 49.412C180.323 51.897 180.323 71.973 180.323 71.973H188.152V76.572H183.739V73.837H178.586V78.188C178.586 78.188 178.586 80.425 181.007 80.425C183.428 80.425 200.835 80.425 200.835 80.425C200.835 80.425 202.821 80.611 202.821 78C202.821 75.391 202.821 73.836 202.821 73.836H197.664V76.571H193.062V71.972H207.047V80.425H212.147V70.17C212.147 70.17 212.205 68.058 209.535 68.058ZM185.544 50.532H206.86V51.897H185.544V50.532ZM185.544 55.691H206.86V57.055H185.544V55.691Z",
  fill: "#595757"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M94.3569 86.2373H93.0889V94.0753H94.3569V86.2373Z",
  fill: "#595757"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M94.1982 89.9803L98.3062 86.2373H99.7272L95.9142 89.9563L100.088 94.0753L98.3032 94.0813L94.2682 90.0693",
  fill: "#595757"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M103.306 86.2373L99.9771 94.0753H101.307L102.145 91.9763H106.09L106.944 94.0753H108.276L104.923 86.2373H103.306ZM102.501 91.0873L104.099 87.0783L105.731 91.0873H102.501Z",
  fill: "#595757"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M129.641 86.2373H128.025L124.692 94.0753H126.024L126.862 91.9763H130.808L131.663 94.0753H132.996L129.641 86.2373ZM127.215 91.0873L128.815 87.0783L130.45 91.0873H127.215Z",
  fill: "#595757"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M112.709 86.2373H111.511V91.6973C111.511 91.6973 111.62 93.1353 110.091 93.1353H107.628V94.0763H109.94C109.94 94.0763 112.709 94.2333 112.709 91.6083C112.709 88.9793 112.709 86.2373 112.709 86.2373Z",
  fill: "#595757"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M114.929 86.2373H113.707V94.0753H114.929V86.2373Z",
  fill: "#595757"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M115.994 86.2373V94.0753H117.133V87.4073L119.749 94.0753H121.017L123.606 87.3623V94.0753H124.759V86.2373H122.946L120.432 92.6643L117.91 86.2373H115.994Z",
  fill: "#595757"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M142.452 87.0736V86.2256H139.202C139.202 86.2256 136.139 86.1816 136.139 90.2986C136.139 94.0986 139.469 94.0516 139.469 94.0516H142.453V93.2036L139.722 93.2056C139.722 93.2056 137.408 93.3746 137.408 90.2776C137.408 86.8666 139.722 87.0586 139.722 87.0586L142.452 87.0736Z",
  fill: "#595757"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M146.439 86.0489C146.439 86.0489 142.631 85.7379 142.631 90.1179C142.631 90.1179 142.148 94.1459 146.439 94.1459C150.615 94.1459 150.281 90.1179 150.281 90.1179C150.282 85.6079 146.439 86.0489 146.439 86.0489ZM148.991 90.1179C148.991 93.7309 146.392 93.3319 146.392 93.3319C146.392 93.3319 143.833 93.7009 143.833 90.1179V90.0909C143.833 86.6839 146.392 86.8889 146.392 86.8889C146.392 86.8889 148.991 86.5459 148.991 90.0909V90.1179Z",
  fill: "#595757"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M169.594 86.0489C169.594 86.0489 165.787 85.7379 165.787 90.1179C165.787 90.1179 165.303 94.1459 169.594 94.1459C173.774 94.1459 173.438 90.1179 173.438 90.1179C173.438 85.6079 169.594 86.0489 169.594 86.0489ZM172.149 90.1179C172.149 93.7309 169.548 93.3319 169.548 93.3319C169.548 93.3319 166.989 93.7009 166.989 90.1179V90.0909C166.989 86.6839 169.548 86.8889 169.548 86.8889C169.548 86.8889 172.149 86.5459 172.149 90.0909V90.1179Z",
  fill: "#595757"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M204.549 90.1179C204.549 85.6079 200.706 86.0489 200.706 86.0489C200.706 86.0489 196.901 85.7379 196.901 90.1179C196.901 90.1179 196.414 94.1459 200.706 94.1459C204.891 94.1459 204.549 90.1179 204.549 90.1179ZM203.263 90.1179C203.263 93.7309 200.659 93.3319 200.659 93.3319C200.659 93.3319 198.1 93.7009 198.1 90.1179V90.0909C198.1 86.6839 200.659 86.8889 200.659 86.8889C200.659 86.8889 203.263 86.5459 203.263 90.0909V90.1179Z",
  fill: "#595757"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M156.28 90.4706C156.28 90.4706 157.879 90.1086 157.879 88.3176C157.879 86.4166 155.877 86.2256 155.339 86.2256C155.042 86.2256 151.176 86.2256 151.176 86.2256V94.0996H152.388V90.6556H154.107C154.107 90.6556 156.451 90.4716 156.451 92.7976C156.451 92.7976 156.544 93.9316 156.613 94.1006H157.894C157.894 94.1006 157.731 92.9906 157.71 92.7766C157.689 92.5616 157.582 91.0686 156.28 90.4706ZM154.917 89.7566H152.388V87.0596H154.917C154.917 87.0596 156.579 86.9086 156.579 88.4226C156.579 90.0446 154.917 89.7566 154.917 89.7566Z",
  fill: "#595757"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M179.441 90.4706C179.441 90.4706 181.043 90.1086 181.043 88.3176C181.043 86.5266 178.941 86.2256 178.646 86.2256C178.348 86.2256 174.343 86.2256 174.343 86.2256V94.0996H175.555V90.6556H177.436C177.436 90.6556 179.59 90.6656 179.615 92.7976C179.615 92.7976 179.707 93.9316 179.777 94.1006H181.059C181.059 94.1006 180.893 92.9906 180.872 92.7766C180.851 92.5616 180.745 91.0686 179.441 90.4706ZM178.077 89.7566H175.555V87.0596H178.077C178.077 87.0596 179.742 86.9086 179.742 88.4226C179.742 90.0446 178.077 89.7566 178.077 89.7566Z",
  fill: "#595757"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M162.7 86.2266H158.819V94.0996H160.027V91.1336H162.717C162.717 91.1336 165.197 91.3476 165.197 88.5946C165.198 86.1826 162.7 86.2266 162.7 86.2266ZM162.7 90.2786H160.014V87.0596H162.7C162.7 87.0596 163.921 86.9526 163.921 88.6176C163.92 90.2786 162.7 90.2786 162.7 90.2786Z",
  fill: "#595757"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M184.553 86.2266L181.227 94.0996H182.443L185.325 87.2166L188.135 94.0996H189.418L186.087 86.2266H184.553Z",
  fill: "#595757"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M187.498 91.1338H183.08V91.9868H187.498V91.1338Z",
  fill: "#595757"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M187.879 86.2266V87.0596H190.731V94.0996H191.949V87.0596H194.639V94.0996H195.854V86.2266H187.879Z",
  fill: "#595757"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M205.423 86.2266V94.0996H206.543V87.8906L210.927 94.0996H212.147V86.2266H211.027V92.4346L206.799 86.2266H205.423Z",
  fill: "#595757"
});

var _ref29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b",
  x: -4,
  y: -4,
  width: 314,
  height: 148,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

function SvgLogoKajima(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 140,
    viewBox: "0 0 306 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKajima);
export default __webpack_public_path__ + "static/media/logo_kajima.4413d383.svg";
export { ForwardRef as ReactComponent };